var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { ref, onBeforeMount } from 'vue';
import { checkForNewsUpdate, checkForMessageUpdate } from '../api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MyCafeMenu',
    setup: function (__props) {
        var _this = this;
        /**
         * 내카페 > 카페 수익 관리 페이지에서 노출되는 메뉴 컴포넌트
         *
         * 공통으로 사용하는 MyCafeMenu.vue 컴포넌트가 있지만
         * 카페 수익 관리 페이지는 ts로 작성하여 사용할 수 없어 따로 구현한다.
         */
        var menuList = ref([
            {
                name: '내 카페 목록',
                href: '/_c21_/my_cafe',
            },
            {
                name: '북마크',
                href: '/_c21_/my_bookmark',
            },
            {
                name: '탈퇴 카페 관리',
                href: '/_c21_/exit_cafe',
            },
            {
                name: '카페 수익 관리',
                href: '/_c21_/profit',
                isSelected: true,
            },
        ]);
        var subMenuList = ref([
            {
                name: '알림',
                href: '/_c21_/my_news',
                hasNew: false,
            },
            {
                name: '쪽지',
                href: '/_c21_/my_message',
                hasNew: false,
            },
        ]);
        onBeforeMount(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, newsUpdated, messageUpdated, NEWS_INDEX, MESSAGE_INDEX;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([checkForNewsUpdate(), checkForMessageUpdate()])];
                    case 1:
                        _a = _b.sent(), newsUpdated = _a[0], messageUpdated = _a[1];
                        NEWS_INDEX = 0;
                        MESSAGE_INDEX = 1;
                        subMenuList.value[NEWS_INDEX].hasNew = newsUpdated;
                        subMenuList.value[MESSAGE_INDEX].hasNew = messageUpdated;
                        return [2 /*return*/];
                }
            });
        }); });
        return { __sfc: true, menuList: menuList, subMenuList: subMenuList };
    }
});
